import { render, staticRenderFns } from "./ClientOverview_RequestActivity.vue?vue&type=template&id=5afa756c&scoped=true&"
import script from "./ClientOverview_RequestActivity.vue?vue&type=script&lang=js&"
export * from "./ClientOverview_RequestActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa756c",
  null
  
)

export default component.exports